import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "form-container narrow" }
const _hoisted_2 = { class: "form-container narrow" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_nova_import_form = _resolveComponent("nova-import-form")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { class: "d-flex justify-center flex-wrap" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _cache[1] || (_cache[1] = _createElementVNode("span", { class: "form-header" }, "Export", -1)),
        _createTextVNode(" " + _toDisplayString($setup.state.selectedApi) + "Form ", 1),
        _createVNode(_component_v_form, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_select, {
              required: "",
              density: "compact",
              label: "Select WMS",
              variant: "outlined",
              items: $setup.apiOptions,
              modelValue: $setup.state.selectedApi,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.state.selectedApi) = $event))
            }, null, 8, ["items", "modelValue"]),
            (_openBlock(), _createBlock(_resolveDynamicComponent(`${$setup.state.selectedApi}Form`)))
          ]),
          _: 1
        })
      ]),
      _createVNode(_component_v_icon, {
        class: "align-self-center mx-8",
        size: "x-large"
      }, {
        default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
          _createTextVNode("mdi-transfer-right", -1)
        ]))]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_2, [
        _cache[3] || (_cache[3] = _createElementVNode("span", { class: "form-header" }, "Import", -1)),
        _createVNode(_component_nova_import_form)
      ])
    ]),
    _: 1
  }))
}